import "./Motive.css";

export default function Motive() {
    return (
        <div className="motive-wrapper">
            <p className="motive-pill">AI-Powered Business Intelligence</p>
            <p className="motive-sub">Validate ideas, map strategy, and launch faster — all in one platform.</p>
        </div>
    );
}
